Object.defineProperty(exports, "__esModule", { value: true });
exports.tableModelConfig = void 0;
const core_1 = require("@wheelroom/core");
const wheel_topic_1 = require("@wheelroom/wheel-topic");
exports.tableModelConfig = {
    tableRow: {
        fields: {
            variation: {
                items: ['header', 'body', 'footer'],
                type: 'dropdown',
            },
            heading: {
                type: 'shortText',
            },
            abstract: {
                type: 'longText',
            },
            icon: {
                items: core_1.featherIconNames,
                type: 'dropdown',
            },
            actions: {
                allowedComponents: ['action'],
                type: 'multipleComponents',
            },
            topics: {
                allowedComponents: ['topic'],
                type: 'multipleComponents',
            },
        },
        settings: {
            asBoilerplate: true,
            asFragment: true,
        },
        modelVersion: '1.0.0',
    },
    tableSection: {
        fields: {
            variation: {
                items: ['table', 'price'],
                type: 'dropdown',
            },
            topicOptions: {
                items: Object.values(wheel_topic_1.topicOptionsEnglish),
                translations: {
                    name: {
                        nl: 'Onderwerp opties',
                    },
                    helpText: {
                        nl: 'Deze opties passen de weergave van de onderwerpen in de sectie aan.',
                    },
                    items: {
                        nl: Object.values(wheel_topic_1.topicOptionsDutch),
                    },
                },
                type: 'checkbox',
            },
            tableRows: {
                allowedComponents: ['tableRow'],
                type: 'multipleComponents',
            },
            eventId: {
                type: 'shortText',
                initialContent: 'initial-content-for-table-section-event-id',
                typePostfix: 'Slug',
                helpText: 'Example: my-event-id',
                unique: true,
            },
        },
        modelVersion: '1.0.0',
        settings: {
            asBoilerplate: false,
            asFragment: true,
            asPageSection: true,
        },
    },
};
//# sourceMappingURL=table-model-config.js.map